import { render } from "./TrfWizardModuloDepartamentos.vue?vue&type=template&id=45c9fe76&scoped=true"
import script from "./TrfWizardModuloDepartamentos.vue?vue&type=script&lang=js"
export * from "./TrfWizardModuloDepartamentos.vue?vue&type=script&lang=js"

import "./TrfWizardModuloDepartamentos.vue?vue&type=style&index=0&id=45c9fe76&lang=scss&scoped=true"

import exportComponent from "/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45c9fe76"],['__file',"src/components/WizardConfiguracaoPendente/TrfWizardModuloDepartamentos.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "45c9fe76"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('45c9fe76', __exports__)) {
    console.log('reload')
    api.reload('45c9fe76', __exports__)
  }
  
  module.hot.accept("./TrfWizardModuloDepartamentos.vue?vue&type=template&id=45c9fe76&scoped=true", () => {
    console.log('re-render')
    api.rerender('45c9fe76', render)
  })

}


export default __exports__